import * as React from 'react';
import styled from '@emotion/styled';
import { Btn, ButtonType, ButtonWidget } from './ButtonWidget';

export interface GroupedButtonsProps {
  btns: Btn[];
}

export const GroupedButtons: React.FC<GroupedButtonsProps> = (props) => {
  const numberOfButtons = props.btns.length;

  return (
    <S.Container>
      {props.btns.map((btn, index) => {
        const fallbackType = numberOfButtons > 1 && index > 0 ? ButtonType.PRIMARY : ButtonType.SECONDARY;
        return (
          <React.Fragment key={`group-${index}`}>
            <S.Button {...btn} key={`grouped-button-${index}`} type={btn.type ?? fallbackType} />
            {index < numberOfButtons - 1 && <S.ButtonSpacer />}
          </React.Fragment>
        );
      })}
    </S.Container>
  );
};

namespace S {
  export const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  `;

  export const Button = styled(ButtonWidget)``;

  export const ButtonSpacer = styled.div`
    width: 8px;
  `;
}
